module.exports = __webpack_public_path__ + "img/网络日志.2734fb60.jpg";